import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Envelope } from '../../interfaces/envelope';
import { Zone } from '../../interfaces/zones';
import { zoneService } from '../services/zone.service';

interface ZoneState {
	zones: {
		[id: number]: Zone;
	};
	selectedZone: Zone | undefined;
	isLoading: boolean;
}

const initialState = {
	zones: [],
	selectedZone: undefined,
	isLoading: false,
} as ZoneState;

export const fetchZones = createAsyncThunk<
	Zone[],
	void,
	{
		rejectValue: Envelope<[]> | unknown;
	}
>('zone/fetchZones', async (_undefined, { rejectWithValue }) => {
	try {
		return await zoneService.fetchZones();
	} catch (error) {
		return rejectWithValue(error);
	}
});

const zoneSlice = createSlice({
	name: 'zone',
	initialState,
	reducers: {
		selectZone: (state, action: PayloadAction<number>) => {
			state.selectedZone = state.zones[action.payload];
		},
		deSelectZone: (state) => {
			state.selectedZone = undefined;
		},
		resetZone: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchZones.fulfilled, (state, action) => {
			const ret: { [id: number]: Zone } = {};
			state.zones = action.payload.reduce((obj, zone) => {
				obj[zone.id] = zone;
				return obj;
			}, ret);
			state.isLoading = false;
		});
		builder.addCase(fetchZones.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchZones.rejected, (state, action) => {
			state.zones = [];
			state.isLoading = false;
		});
	},
});

export const { selectZone, deSelectZone, resetZone } = zoneSlice.actions;

export default zoneSlice;
